export const styles = theme => ({
  root: {
    width: 240,
    backgroundColor: "#FFFFFF"
  },
  clear: {
    color: theme.palette.text.secondary,
    cursor: "pointer"
  }
});